import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.346 11.283h13.333l-.025 1.459H5.321z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.283 18.68V5.345l1.459-.025v13.333z"
    }, null, -1)
  ])))
}
export default { render: render }